export type {JsonMapType} from './codec.js'
